<div class="flex flex-col gap-1">
  <button
    type="button"
    class="text-text-secondary hover:text-text-primary flex items-center gap-1.5 self-start rounded-sm text-xs transition-colors"
    [attr.aria-expanded]="expanded()"
    (click)="expanded.set(!expanded())">
    <i [class]="expanded() ? ICONS.caretDown : ICONS.caretRight"></i>
    <span>{{ header() | translate: { count: tools().length } }}</span>
    @if (!streaming() && duration(); as duration) {
      <span class="text-text-tertiary text-2xs font-mono tabular-nums"
        >· {{ duration }}</span
      >
    }
  </button>
  @if (expanded()) {
    <!-- The rail threads the steps in the order they ran. -->
    <div class="border-weak ml-1.5 flex flex-col gap-1.5 border-l pl-3">
      @for (tool of tools(); track tool.callId) {
        <app-assistant-tool-line [tool]="tool" [detail]="true" />
      }
    </div>
  } @else if (streaming()) {
    <div class="ml-1.5 flex flex-col gap-1 pl-3">
      @for (tool of running(); track tool.callId) {
        <app-assistant-tool-line [tool]="tool" />
      }
    </div>
  }
</div>
